<div class="timetable">
  @for (item of data?.dates; track item) {
    <div [style]="{ '--color': item.color || '#2db4e1' }" class="time-point-root">
      <div [ngClass]="{ placeholder: !item.date && !item.hasNoDate }" class="time-point-root-container">
        <div class="text-container">
          <div class="row">
            <h6>{{ item.title | translate }}</h6>

            <!-- Freeze date should have additional info button + modal -->
            @if (item.title === "timeline.freezeDate") {
              <div class="info-button icon-circle-information" (click)="openInfoModal()"></div>
            }
          </div>
          <span>{{ (item.date | date: "MMM d, y") || "" }}</span>
        </div>
        <div [ngClass]="{ unset: !item.date && !item.hasNoDate }" class="timeline-item">
          <div class="timeline-item-top">
            <div class="timeline-item-top-marker"></div>
          </div>
          <div [ngClass]="{ hoverable: !!item.tooltip }" class="timeline-item-bottom">
            <div [matTooltip]="item.tooltip || null" class="timeline-item-bottom-circle">
              @if (item.icon || !!item.mailType) {
                <fa-icon (click)="item.onClick && item.onClick(item)" [icon]="item.icon || ['fas', 'mail-bulk']"></fa-icon>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
